import React, { useEffect } from 'react';
import { Tabs } from '@b-design/fusion';
import store from '@/store';
import { history } from 'ice';
import EmptyHeader from '@/components/EmptyHeader';
import styles from './index.module.less';
import SiteSetting from './components/site';
import CommonHeader from '@/components/CommonHeader';
import TermsAndPolicy from './components/termsAndPolicy';
// import DocumentSetting from './components/documentSetting';
import $i18n from '../../i18n';

const Settings: React.FC = () => {
  const [userState] = store.useModel('user');

  // useEffect(() => {
  //   if (userState?.currentUser?.tenantRole !== 'ADMIN') {
  //     history?.push(`/?spaceId=${userState?.currentUser?.defaultSpace?.spaceId || ''}`);
  //   }
  // }, []);

  return (
    <div className={styles.settingContent}>
      <EmptyHeader />
      <div className={styles.setting}>
        <CommonHeader
          title={$i18n.get({ id: 'aopf.pages.settings.General', dm: '常规设置' })}
          goBack
        />
        <div className={styles.settingsTab}>
          <Tabs shape="wrapped">
            <Tabs.Item
              title={$i18n.get({
                id: 'aopf.pages.settings.site',
                dm: '网站设置',
              })}
              key="1"
            >
              <SiteSetting />
            </Tabs.Item>
            <Tabs.Item
              title={$i18n.get({
                id: 'aopf.pages.settings.terms',
                dm: '条款和政策',
              })}
              key="2"
            >
              <TermsAndPolicy />
            </Tabs.Item>
            {/* <Tabs.Item
              title={$i18n.get({
                id: 'aopf.pages.settings.title.document.setting',
                dm: '文档设置',
              })}
              key="3"
            >
              <DocumentSetting />
            </Tabs.Item> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Settings;
